import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDOq6r-3jYjVUeyqLq3dL3xHwJjb0DC3NM",
  authDomain: "htst-e6e0e.firebaseapp.com",
  projectId: "htst-e6e0e",
  storageBucket: "htst-e6e0e.firebasestorage.app",
  messagingSenderId: "378420077388",
  appId: "1:378420077388:web:68d73fa36a19a19085a5e9",
  measurementId: "G-XL8ZRM8TDJ"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// experimentalAutoDetectLongPolling: automatically falls back to long-polling
// when WebChannel streaming is blocked or mangled — this is the standard fix
// for Firestore reads silently hanging/failing on mobile carrier networks
// (very common with Indian mobile ISPs' transparent proxies), while working
// fine on wifi/desktop.
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false,
});

export default app;